import React from 'react';
import Config from '../config';
import { lightGray, white } from '../styles/style-constants';
import { makeStyles } from '@mui/styles';

const WorksheetMaker = () => {
  const { worksheet, content, applicationFrame } = useStyles();

  return (
    <div className={worksheet}>
      <div className={content}>
        <iframe title={`LWT App Viewer`} src={Config.wmUrl} className={applicationFrame} />
      </div>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  worksheet: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: white
  },
  content: {
    overflowY: 'auto',
    backgroundColor: lightGray,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-start'
  },
  applicationFrame: {
    width: '100%',
    height: '100%'
  }
}));

export default WorksheetMaker;
